<ng-container *ngIf="interface.loading">
  <ui-control-dashboard></ui-control-dashboard>
</ng-container>
<router-outlet (activate)="childContentLoad($event)" (deactivate)="childContentUnLoad($event)"></router-outlet>
